import React from "react";
import StaticPage from "../../components/StaticPage";

const About = () => (
    <StaticPage
        title="About PILLS"
        crumb="About"
        testId="page-about"
        intro="PILLS is India's AI-powered healthcare commerce platform — combining a full e-pharmacy with intelligent triage, refill prediction, drug-interaction checks, lab tests, doctor consultations and B2B fulfilment for clinics, hospitals and labs."
        sections={[
            {
                heading: "Our mission",
                body: "Bring transparent, AI-augmented pharmacy access to every household in India — with the genuine medicine, the right dose, on time, every time.",
            },
            {
                heading: "What makes us different",
                body: "Verified suppliers, batch-level traceability, FIFO inventory across rack/shelf/bin locations, 13-language support, prescription watermarking for security, and a back-office trusted by independent pharmacists.",
            },
            {
                heading: "Built in India, for India",
                body: "Headquartered in Chennai, with serviceable pin-codes across 19,000+ locations through our Shiprocket partnership. GST-compliant invoicing for individuals and businesses.",
            },
        ]}
    />
);

export default About;
